import React, { useContext } from "react"
import { Grid } from "@mui/material"

import __t from "../../../lib/traduzioni"
import BSSPreventivoContext from "../../../contexts/BSSPreventivoContext"
import ComparatorePrezzi from "../comparatore_prezzi/ComparatorePrezzi";

const FrammentoPrezzi = ({methods, classes, aggiornaPreventivoStorage, onSubmit, clauses, setClauses, immaginepreventivodefault}) => {

    const {preventivi} = useContext(BSSPreventivoContext);

    const subProps = {
        preventivi,
        aggiornaPreventivoStorage,
        onSubmit,
        methods,
        clauses,
        setClauses,
        immaginepreventivodefault
    }

    return (
        <>            

            <Grid item xs={12} className={classes.formGroupBox}>
                <ComparatorePrezzi {...subProps} />
            </Grid>
        </>
    )
}

export default FrammentoPrezzi